import { Component, OnInit } from "@angular/core";

import { ValidatorHelper } from "../shared";

@Component({
  selector: "app-panel",
  templateUrl: "./panel.component.html",
  styleUrls: ["./panel.component.scss"]
})
export class PanelComponent implements OnInit {
  constructor(public validator: ValidatorHelper) {}

  ngOnInit() {}
}
